import { useNavigate } from '@tanstack/react-router';
import { Button, Divider, Typography } from '@/primer/components';
import { SocialLoginButtons } from '@/components/ui/SocialLoginButtons';
import { PageLayout } from '@/components/layout';

export function Landing() {
  const navigate = useNavigate();

  return (
    <PageLayout className="py-8" gridProps={{ className: 'px-5' }}>
      <div className="flex flex-col gap-6">
        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={() => void navigate({ to: '/signin/email' })}
          data-testid="continue-with-email-button"
        >
          Continue with email
        </Button>

        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Divider />
          </div>
          <Typography variant="body" size="medium" color="bodylighter" as="span">
            Or
          </Typography>
          <div className="flex-1">
            <Divider />
          </div>
        </div>

        <SocialLoginButtons />
      </div>
    </PageLayout>
  );
}

export default Landing;
